<template>
  <div class="friend-page">
    <div class="grade-select">
      <p>请选择宝贝年级</p>
      <div class="grade-options">
        <div @click="grade=0" :class="{'grade-item':true,'select-op':grade===0}">幼儿园大班</div>
        <div @click="grade=1" :class="{'grade-item':true,'select-op':grade===1}">小学一年级</div>
      </div>
    </div>
    <div class="sub-btn">确认</div>
  </div>
</template>
<script>
// import sasdk from './sasdkinit'
export default {
  data () {
    return {
      grade: 0
    }
  },
  mounted () {
    // sasdk.viewindex()
    // console.log('aaa')
  }
}
</script>
<style lang="scss" scoped>
  .friend-page{
    background: url('~@/assets/img/makefriend/bg.png') no-repeat;
    width:750px;
    background-size:746px 1378px;
    background-position: center top;
    min-height:1378px;
    height:100vh;
    margin:0 auto;
    position: relative;
    background-color:white;
  }
  .grade-select{
    position: absolute;
    top:840px;
    width:750px;
    height:320px;
    background: url('~@/assets/img/makefriend/btnbg.png') no-repeat;
    background-size:795px 320px;
    background-position: center;
    p{
      font-size: 30px;
      color: #272727;
      margin:91px 0 0 99px;
    }
  }
  .grade-options{
    width:560px;
    margin:30px auto 0;
    display: flex;
    justify-content: space-between;
  }
  .grade-item{
    width:248px;
    height:61px;
    line-height: 61px;
    color:#272727;
    font-size: 26px;
    background-size:contain;
    background-repeat: no-repeat;
    background-image: url('~@/assets/img/makefriend/unselect.png');
    text-indent:76px;
  }
  .select-op{
    color:white;
    background-image: url('~@/assets/img/makefriend/selected.png');
  }
  .sub-btn{
    position:fixed;
    left:90px;
    bottom:60px;
    width:560px;
    line-height:96px;
    height:96px;
    border-radius: 48px;
    font-size: 50px;
    font-weight: bold;
    color:white;
    background:#317EFF;
    text-align: center;
  }
</style>
